import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, Input,Row, Col } from 'reactstrap';
import * as XLSX from "xlsx";
import Select from 'react-select';
import { toast } from 'react-toastify';
import Table from "../../components/UI/Table/Table";
import { setPageView} from '../../components/GoogleAnalytics/index';
import {EXCEL_COLUMNS} from "./constants"
import { Preloading } from '../../components/UI/Preloader/action';
import { dataUpload, getDataList, downloadStarRatingResult } from './action'
const SoucesTypes = [{ value: "MCA", label: "MCA" }, { value: "PF", label: "PF" }, { value: "GST", label: "GST" }, { value: "CONTACT_DETAIL", label: "Contact Detail" }, { value: "LEI", label: "LEI" }, { value: "STAR_RATING", label: "Star Ratings" }]
class DataUploadUtility extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            selectedOption:"",
            fileId:"",
            utilityPageType:props.utilityPageType,
            dataList:[],
            message:null,
            failureReason:"",
            tableColumn:false,
            fileType:"",
            invalidData:false,
            selectedRow:null,
        }
        const that = this;
    }
    componentDidMount(){
        setPageView('../Admin/Data-Upload', document.location.href);
        this.props.preloading(true);
        this.props.getDataList();
    }
    componentDidUpdate(prevProps){
        if (this.props.dataList !== prevProps.dataList) {
            this.setState({dataList:this.props.dataList.data.reverse()})
            this.props.preloading(false);
        }
    }
    handleChange=(e)=>{
        this.setState({selectedOption:e})
    }
    handleSubmit=()=>{
        if(this.state.selectedOption == "" || this.state.fileId == ""){
            alert("fill all mandatory fields")
        }
        else{
            this.props.preloading(true);
            if(this.state.fileId.search(".zip")!=-1){
                let fileDetails = {}
                fileDetails.fileId = this.state.fileId
                fileDetails.fileType = this.state.selectedOption.value
                fileDetails.createdAt = new Date().toLocaleString()
                fileDetails.updatedAt = new Date().toLocaleString()
                fileDetails.status = "PENDING"
                this.setState(prevState => ({
                    dataList: [fileDetails, ...prevState.dataList]
                }))
                this.props.dataUpload({
                    fileId: this.state.fileId,
                    filetype:this.state.selectedOption.value
                })
                this.setState({fileId:"",selectedOption:""})
                this.props.preloading(false);
            }else{
                alert("Please Upload Zip File Only!!");
                this.props.preloading(false);
            }
        }
    }
    handleDownload =()=>{
        var worksheet = "";
        if(this.state.selectedOption.value == "PF") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.PF);
        else if(this.state.selectedOption.value == "MCA") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.MCA);
        else if(this.state.selectedOption.value == "Rating") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.Rating);
        else if(this.state.selectedOption.value == "GST") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.GST);
        else if(this.state.selectedOption.value == "CONTACT_DETAIL") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.CONTACT_DETAIL);
        else if(this.state.selectedOption.value == "LEI") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.LEI);
        else if(this.state.selectedOption.value == "STAR_RATING") worksheet = XLSX.utils.json_to_sheet(EXCEL_COLUMNS.STAR_RATING);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet);
        XLSX.writeFile(workbook, this.state.selectedOption.value+" Data Template.xlsx");
    }
    handleDownloadStarRatingResult=(row)=>{
        const fileName = row.fileId && row.fileId.endsWith(".zip")
            ? row.fileId.replace(".zip", "") + "_STAR_RATING_result.xlsx"
            : "star-rating-result.xlsx";
        this.props.downloadStarRatingResult(row.id, fileName);
    }
    viewStatus=(action, message, failureReason,status,fileType,row=null)=>{
        if(status == "PENDING"){
            toast.warn(
                <div>
                    <i className="fa fa-clock-o"> </i> Data uploading status is pending...
                </div>
            );
        }else if(status == "INPROGRESS"){
            toast.info(
                <div>
                    <i className="fa fa-spinner"> </i> Uploading is inprogress..
                </div>
            );
        }else if(fileType=="" && status=="" && failureReason==""){
            this.setState({tableColumn:false,show:false,invalidData:false,selectedRow:null})
        }
        else if(row && row.fileType === "STAR_RATING" && status === "SUCCESS" && row.s3Key){
            this.setState({
                show: action,
                failureReason,
                fileType,
                message: message || "",
                tableColumn: false,
                invalidData: false,
                selectedRow: row,
            });
        }
        else if(failureReason && failureReason.search("Invalid Data") != -1){
            try{
                let invalidDataList = [];
                JSON.parse(message).map((rows)=>{
                    var unMatchedColumn = Object.keys(EXCEL_COLUMNS[fileType][0]).filter(function(obj) { return Object.keys(rows).indexOf(obj) == -1; });
                    let valueList = Object.values(rows);
                    unMatchedColumn.map((name)=>{
                        valueList.splice(Object.keys(EXCEL_COLUMNS[fileType][0]).indexOf(name), 0, "Not Found");
                    })
                    invalidDataList.push(valueList);
                })
                this.setState({message:Object.entries(invalidDataList),invalidData:true})
            }catch(err){
                this.setState({message:message})
            }        
            this.setState({show:action,failureReason:failureReason,fileType:fileType,selectedRow:row})
        }else{
            try{
                this.setState({message:JSON.parse(message),show:true,tableColumn:true,selectedRow:row})
            }catch(err){
                this.setState({message:message,selectedRow:row})
            }        
            this.setState({show:action,failureReason:failureReason,fileType:fileType})
        }
    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Data Upload</h4>
                </div>
                {this.state.show ? 
                    <div className={"model"}>
                        <Button onClick={()=>this.viewStatus(false, "", "","","")} className={"btn btn-secondary"}>Close</Button>
                        <br></br>
                        <lable className={"lable"}>Failure Reason : </lable>
                        <message className={"message font-weight-bold"}>{this.state.failureReason}</message>
                        <br></br>
                        <lable className={"lable"}>Message : </lable>
                        {this.state.invalidData?
                        <div className="App">
                        <table>
                            <tbody>
                          <tr>
                            {Object.keys(EXCEL_COLUMNS[this.state.fileType][0]).map((columnName, index)=><th key={index}>{columnName}</th>)}
                          </tr>
                          {this.state.message.map((val, key) => {
                            return (
                              <tr key={key}>
                                {Object.values(val[1]).map((row, index) =><td key={index}>{row}</td>)}
                              </tr>
                            )
                          })}
                          </tbody>
                        </table>
                      </div>
                        :null}
                        {this.state.tableColumn? <div>
                            <table>
                                <tbody>
                            <message className={"message font-weight-bold text-danger"}>*Note : Following column are not mached with upload file</message>

                            {this.state.message.map((val) =>(
                                <tr key={index}> 
                                <tr key={`filename-${index}`}> {Object.values(val)[0].length != 0 ? "File Name : "+Object.keys(val) :null } </tr>
                                {Object.values(val)[0].length != 0 ? Object.values(val).map((row) =><tr key={`row-${i}`} className='text-light bg-danger'>{"  " + row + "  "}</tr>):null}   
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>
                        :
                        null
                        }
                        {!this.state.invalidData && !this.state.tableColumn?<message className={"message font-weight-bold"}>{this.state.message}</message>:null}
                        {this.state.selectedRow
                            && this.state.selectedRow.fileType === "STAR_RATING"
                            && this.state.selectedRow.status === "SUCCESS"
                            && this.state.selectedRow.s3Key ? (
                            <div className="mt-3">
                                <Button color="primary" onClick={() => this.handleDownloadStarRatingResult(this.state.selectedRow)}>
                                    Download result Excel
                                </Button>
                            </div>
                        ) : null}
                    </div>
                :
                    <div>
                        <Card>
                            <CardBody>
                            <div>
                            <Row className="mb-3 align-items-center">
                            <Col xs="4" className="filter-category py-0 py-sm-20">
                                <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Excel Type</span>
                            </Col>
                            <Col sm={5}>
                            <Select
                                    value={this.state.selectedOption}
                                    onChange={this.handleChange}
                                    options={SoucesTypes}/>
                            
                            </Col>
                            
                            {this.state.selectedOption && 
                            <Button onClick={this.handleDownload} style={{float:"right"}}>Download Template</Button>
                            }
                            </Row>
                            <Row className="mb-3 align-items-center">
                            <Col xs="4" className="filter-category py-0 py-sm-20">
                                <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">File Id</span>
                            </Col>
                            
                            <Col sm={5}>
                            <Input className="bg-light" type="text" name="fileId" value={this.fileId} onChange={e=>{this.setState({fileId:e.target.value})}} placeholder="Enter FileId"/>
                            </Col>
                            <Col xs="4" className="filter-category py-0 py-sm-20">
                            <Button onClick={this.handleSubmit.bind(this)} className="btn btn-success">Submit</Button>
                            </Col>
                            </Row>
                            </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <Table
                                    data={Array.isArray(this.state.dataList) ? this.state.dataList : []}
                                    noDataText="No Uploaded data found"
                                    columns={
                                        [
                                            {
                                                Header: "File Name",
                                                id: "fileId",
                                                accessor: "fileId",
                                                className: 'center',
                                                minWidth: 60
                                            },
                                            {
                                                Header: "File Type",
                                                id: "fileType",
                                                accessor: "fileType",
                                                className: 'center',
                                                minWidth: 25
                                            },
                                            {
                                                Header: "Created At",
                                                id: "createdAt",
                                                accessor: "createdAt",
                                                className: 'center',
                                                minWidth: 63
                                            },
                                            {
                                                Header: "Updated At",
                                                id: "updatedAt",
                                                accessor: "updatedAt",
                                                className: 'center',
                                                minWidth: 63
                                            },
                                            {
                                                Header: "Status",
                                                id: "status",
                                                accessor:p => <button type="button" onClick={() => this.viewStatus(true, p.message, p.failureReason,p.status,p.fileType,p)} className={"btn btn-"+(p.status == "PENDING" ? "warning" : (p.status == "SUCCESS" ? "success" : (p.status == "FAILED" ? "danger" : (p.status == "INPROGRESS" ? "primary" : "secondary"))))+" btn-sm"}><i id={p.status}>{p.status}</i></button>,
                                                className: 'center',
                                                minWidth: 30
                                            }

                                        ]
                                    }
                                    defaultPageSize={10}
                                />
                            </CardBody>
                        </Card>
                    </div>
                }
            </Col>
        )
    }
}
const mapStateToProps=(state)=>({
    dataList:state.dataList.dataListSuccess
})
const mapDispatchToProps = (dispatch) => ({
    dataUpload: data => { dispatch(dataUpload(data))},
    getDataList: (data) => { dispatch(getDataList(data))},
    downloadStarRatingResult: (recordId, fileName) => { dispatch(downloadStarRatingResult(recordId, fileName))},
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading))} 
});
export default connect(mapStateToProps,mapDispatchToProps)(DataUploadUtility);
